<!-- 会议细节页面 加入和退出分会 及分会成员 页面  点击跳转至该页面 我的校友卡页面 -->
<template>
  <div>
    <div class="alumni-detail-box">
      <div class="swiper-box">
        <van-swipe class="alumni-img-box" :autoplay="3000" indicator-color="white" @change="onSwiperChange">
          <van-swipe-item>
            <img v-if="photoUrl != null" v-lazy="photoUrl" />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">1/1</div>
          </template>
        </van-swipe>
      </div>
      <!-- 基本信息 -->
      <div class="user-base-info">
        <div class="name">{{ alumniInfo.name }}</div>
        <div style="margin-bottom: 5px;">{{ alumniInfo.zhiwei }}</div>
        <div>{{ alumniInfo.danwei }}</div>
      </div>
      <!-- 行业领域 -->
      <div class="info-item-box">
        <div class="titleDiv">
          <div class="titleIcon"></div>
          <div class="titleWord">行业领域</div>
        </div>
        <div v-if="alumniInfo.industry != null" class="info-item-card">
          <template v-if="alumniInfo.industry.indexOf('/') > -1">
            <template v-if="alumniInfo.industry.split('/').length === 3">
              {{ alumniInfo.industry.split('/')[0] }}/{{ alumniInfo.industry.split('/')[1] }} > {{ alumniInfo.industry.split('/')[2] }}
            </template>
            <template v-else>
              {{ alumniInfo.industry.split('/')[0] }} > {{ alumniInfo.industry.split('/')[1] }}
            </template>
          </template>
          <template v-else>
            {{ alumniInfo.industry }}
          </template>
        </div>
      </div>
      <!-- 教育经历 -->
      <div class="info-item-box">
        <div class="titleDiv">
          <div class="titleIcon"></div>
          <div class="titleWord">教育经历</div>
        </div>
        <template v-if="alumniEduList != null && alumniEduList.length > 0">
          <template v-for="(item, index) in alumniEduList">
            <div v-if="index === 0" class="info-item-card">
              <div class="top">
                <div class="top-left">{{ item.college }}</div>
                <div class="top-right">{{ item.xuejie }}届</div>
              </div>
              <div class="bottom">{{ item.major }} · {{ item.xueli }}</div>
            </div>
          </template>
        </template>
      </div>
      <!-- 单位信息 -->
      <div class="info-item-box">
        <div class="titleDiv">
          <div class="titleIcon"></div>
          <div class="titleWord">单位信息</div>
        </div>
        <template v-if="alumniJob != null">
          <div class="info-item-card">
            <div class="top">
              <div class="top-left">{{ alumniJob.danwei }}</div>
              <div class="top-right">{{ alumniJob.office_end || '至今' }}</div>
            </div>
            <div class="bottom">{{ alumniJob.zhiwu }} <span v-if="alumniJob.zhiwu != null && alumniJob.zhicheng != null">·</span>  {{ alumniJob.zhicheng }}</div>
          </div>
        </template>
      </div>
      <!-- 联系方式 -->
      <div class="info-item-box">
        <div class="titleDiv">
          <div class="titleIcon"></div>
          <div class="titleWord">联系方式</div>
        </div>
        <div class="info-item-card">
          <template>
            {{ alumniInfo.phone }}
          </template>
        </div>
      </div>
    </div>
    <!-- 占位 -->
    <div style="height: 60px;"></div>
    <!-- 底部按钮 -->
  <!--   <div class="bottom-btn-box">
      <div v-if="alumniInfo.status == null || alumniInfo.status === '未申请'" class="btn btn-exchange" @click="exchangeCard">交换名片</div>
      <div v-if="alumniInfo.status != null && (alumniInfo.status === '已申请' || alumniInfo.status === '待回复')" class="btn btn-isApply" @click="$toast('已申请,等待通过')">已申请</div>
      <div v-if="alumniInfo.status != null && alumniInfo.status === '已被拒'" class="btn btn-beRefused">已被拒</div>
      <div v-if="alumniInfo.status != null && alumniInfo.status === '已同意'" class="btn btn-exchange-finish">已交换</div>
    </div> -->
  </div>
</template>

<script>
import Base64 from "@/utils/base64";

export default {
  data() {
    return {
      userId: window.localStorage.getItem('user_id') || null,
      alumniId: this.$route.query.alumniId || null,
      currentSwiperIndex: 0,
      myInfo: null,
      alumniInfo: null,
      alumniEduList: null,
      alumniJob: null,
      photoUrl: '',
    }
  },
  created() {
    this.getData()
    this.getPhotoData()
    // this.getMyCard()
  },
  methods: {
    async getData() {
      let base64 = new Base64()
      const res = await this.$http.get("/myFriend/getCardInfo", {
        params: {
          myId: base64.encode(this.userId),
          otherId: base64.encode(this.userId),
        }
      })
      if (res.data == null) return
      this.alumniInfo = res.data.info
      this.alumniEduList = res.data.edu
      this.alumniJob = res.data.job
    },
    async getMyCard() {
      const res = await this.$http.get("/myBusinessCard/getBusinessCard", {
        params: {
          userId: this.userId,
        },
      });
      this.myInfo = res.data.detailInfo
    },
    onSwiperChange(e) {
      this.currentSwiperIndex = e
    },
    phone_hide(phone) {
      if (phone && phone.length === 11) {
        phone = phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      return phone
    },
    async getPhotoData() {
      const res = await this.$http.get(`/xjcard/recompletion?openid=${window.localStorage.getItem("openid")}`)
      if (res.data != null) {
        this.photoUrl = decodeURIComponent(atob(res.data.url));
      }
    },
  }
}
</script>

<style lang="less" scoped>
.alumni-detail-box {
  padding: 2.666667vw;
  color: #333333;
  .swiper-box {
    width: 100%;
    height: 70vw;
    border-radius: 10px;
    margin-bottom: 20px;
    .alumni-img-box {
      height: 100%;
      border: 1px solid #F3F3F3;
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
      border-radius: 10px;
      .van-swipe-item {
        height: 100%;
        border-radius: 10px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
          object-fit: cover;
        }
      }
      .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 2px 12px;
        font-size: 12px;
        border-radius: 999px;
        color: #FFFFFF;
        background: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .user-base-info {
    margin-bottom: 20px;
    padding: 10px 15px;
    background: #FFFFFF;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    font-size: 1.1rem;
    .name {
      font-size: 1.4rem;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
  .info-item-box {
    margin-bottom: 20px;
    .info-item-card {
      margin-top: 10px;
      margin-bottom: 10px;
      padding: 20px 15px;
      border-radius: 10px;
      border: 1px solid #F3F3F3;
      background-color: #FFFFFF;
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
      .top {
        height: 17px;
        .top-left {
          float: left;
          font-weight: bold;
        }
        .top-right {
          float: right;
        }
      }
      .bottom {
        margin-top: 10px;
      }
    }
  }
}
.bottom-btn-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  z-index: 99;
  .btn {
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 1.3rem;
    text-align: center;
    color: #FFFFFF;
  }
  .btn-exchange {
    background-color: #00706E;
  }
  .btn-isApply {
    background-color: #ff976a;
  }
  .btn-beRefused {
    background-color: #ee0a24;
  }
  .btn-exchange-finish {
    background-color: #07c160;
  }
}
.titleDiv {
  display: flex;
  align-items: center;
  //margin: 15px 0;
  height: 6vw;
  width: 100%;
  .titleIcon {
    width: 6px;
    height: 5.666667vw;
    background-color: #00706E;
    border-radius: 15px;
  }
  .titleWord {
    margin-left: 2.666667vw;
    font-size: 1.3em;
    font-weight: bold;
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mine/MyCard.vue